module.exports = __webpack_public_path__ + "img/logo.dc6b0d9f.png";